import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Tooltip } from "react-tooltip";
import ArticleGeneratingSpinner from "../../../components/loaders/ArticleGeneratingSpinner";
import { ArticleStatusEnum } from "../../../enums/article";
import { ArticleStatusColorMap, ArticleStatusMap } from "../../../models";

const ArticleStatus = ({ articleStatusId, generateError }: any) => {
  return (
    <div className="flex gap-1.5 items-center text-sm">
      {articleStatusId !== ArticleStatusEnum.ERROR && (
        <div className="flex gap-1.5 items-center md:text-sm">
          {articleStatusId === ArticleStatusEnum.GENERATING && (
            <div className="w-3.5 h-3.5">
              <ArticleGeneratingSpinner />
            </div>
          )}
          {articleStatusId !== ArticleStatusEnum.GENERATING && (
            <div
              className="w-2 h-2 rounded-full"
              style={{
                background:
                  ArticleStatusColorMap[articleStatusId as ArticleStatusEnum],
              }}
            />
          )}
          {ArticleStatusMap[articleStatusId as ArticleStatusEnum]}
        </div>
      )}
      {articleStatusId === ArticleStatusEnum.ERROR && (
        <div
          className="flex items-center gap-1 text-sm"
          data-tooltip-id="article-generate-error"
          data-tooltip-content={generateError}
        >
          <Tooltip
            id="article-generate-error"
            place="top"
          />
          <ExclamationTriangleIcon className="w-4 h-4 text-red-500" />
          {ArticleStatusMap[articleStatusId as ArticleStatusEnum]}
        </div>
      )}
    </div>
  );
};

export default ArticleStatus;
